import { ContainerModule } from "inversify";
import * as Api from "@/app/question/components/api";
import * as SerializationApi from '@/app/state-serialization/api';
import GroupingQuestionComponent from "./grouping-question-component.vue";
import GroupingQuestionSolutionComponent from "./grouping-question-solution-component.vue";
import { GroupingQuestionAnswerProtobufSerializer } from "./grouping-question-answer-protobuf-serializer";
import { GroupingQuestionStateProtobufSerializer } from "./grouping-question-state-protobuf-serializer";

export const groupingQuestionFactoryModule = new ContainerModule(bind => {
  bind<Api.QuestionComponentPlugin>(Api.QuestionComponentPluginSymbol)
    .toConstantValue(GroupingQuestionComponent)
    .whenTargetNamed("grouping");

  bind<Api.QuestionComponentPlugin>(Api.QuestionSolutionPluginSymbol)
    .toConstantValue(GroupingQuestionSolutionComponent)
    .whenTargetNamed("grouping");

    bind(SerializationApi.StateSerializationPluginSymbol).to(GroupingQuestionAnswerProtobufSerializer)
    bind(SerializationApi.StateSerializationPluginSymbol).to(GroupingQuestionStateProtobufSerializer)  
});
